import React from 'react'
import PageLayout from '../../components/layout/PageLayout'
import {useSearchParams} from 'react-router-dom'
import useQueryKeyDetail from '../../hooks/api/user/userQueryApiDetail'
import KeyInfoContainer from '../../features/page/user/KeyInfoContainer'
import KeySubInfoContainer from '../../features/page/user/KeySubInfoContainer'

interface IProps {
    className?: string
}

const ApiDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const keyId = searchParams.get('id')

    const {data, refetch} = useQueryKeyDetail(keyId)

    return (
        <PageLayout
            title={'Key Info'}
            className={'grid grid-cols-[auto_450px] space-x-[30px] lg:grid-cols-1 lg:space-x-0 lg:gap-y-[50px]'}>
            <div className={'space-y-[30px]'}>
                <KeyInfoContainer data={data} />
            </div>
            <div>
                <KeySubInfoContainer
                    data={data !== undefined ? data.binance_info || data.bybit_info || data.okx_info : undefined}
                />
            </div>
        </PageLayout>
    )
}

export default ApiDetailPage
